import type { AssistantAskResponse, AssistantMessage } from '@unipostudio/shared-types';
import { api } from './api';

/** Ask UniPostudio (UI v2): one question, with the conversation so far. */
export const assistantService = {
  async ask(messages: AssistantMessage[]): Promise<AssistantAskResponse> {
    const res = await api.post<AssistantAskResponse>('/assistant/ask', { messages });
    return res.data;
  },
};
